import { useEffect, useState } from "react";
import { useGetInfoApi } from "../../hooks";
import { useAuthStore, useCommonStore } from "../../store";
import axios from "axios";
import api from "../../config/client.axios.api";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";

const AccountManage = () => {
  const [resetPassword, setResetPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [infomationUpdate, setInfomationUpdate] = useState({
    imageUrl: "",
    firstName: "",
    lastName: "",
  });
  const { reloadInfo, setReloadInfo } = useCommonStore();
  const [loadingChangeInfo, setLoadingChangeInfo] = useState(false);
  const [loadingChangePassword, setLoadingChangePassword] = useState(false);

  const { clearToken } = useAuthStore();

  const { infoDetail } = useGetInfoApi(clearToken, reloadInfo);

  useEffect(() => {
    setInfomationUpdate({
      imageUrl: infoDetail?.data?.url,
      firstName: infoDetail?.data?.firstName,
      lastName: infoDetail?.data?.lastName,
    });
  }, [infoDetail?.data]);

  const handleUpdateInfo = async () => {
    try {
      setLoadingChangeInfo(true);
      const res = await api.put(
        `/account?id=${infoDetail?.data?.id}`,
        infomationUpdate
      );

      if (res?.data?.code === 200) {
        toast.success(res?.data?.message || "Update info user success");
        setReloadInfo(!reloadInfo);
        setLoadingChangeInfo(false);
      } else {
        toast.error(res?.data?.message || "Update info user failure");
        setLoadingChangeInfo(false);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.error || "Update info user failure");
      setLoadingChangeInfo(false);
    }
  };

  const handleChangePassword = async () => {
    try {
      setLoadingChangePassword(true);
      const resultChangePassword = await api.put(
        `/account/password`,
        resetPassword
      );
      setLoadingChangePassword(false);
      if (resultChangePassword?.data?.code === 200) {
        toast.success(
          resultChangePassword?.data?.message || "Update password user success"
        );
        setLoadingChangePassword(false);
      } else {
        toast.error(
          resultChangePassword?.data?.message || "Update password user failure"
        );
        setLoadingChangePassword(false);
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error || "Update password user failure"
      );
      setLoadingChangePassword(false);
    }
  };

  return (
    <div className="w-full flex flex-col gap-4 justify-center items-center h-full">
      <div className="flex flex-col 2xl:w-[60%] xl:w-[70%] lg:w-[80%] w-[90%] bg-white 2xl:p-[18px] xl:p-[14px] lg:p-[12px] p-[10px] rounded-lg">
        <span className="font-semibold text-xl">Change infomation</span>
        <div className="flex flex-col w-full gap-1">
          {infomationUpdate?.imageUrl && (
            <img
              className="xl:w-[130px] xl:h-[130px] w-[70px] h-[70px] mt-4 rounded-full"
              src={infomationUpdate?.imageUrl}
            ></img>
          )}
          <input
            onChange={async (event: any) => {
              const formData = new FormData();
              formData.append("image", event.target.files[0]);

              const res = await axios.post(
                `https://backendapp.phototime.biz/v2/upload/upload`,
                formData
              );

              setInfomationUpdate((prev) => ({
                ...prev,
                imageUrl: res?.data?.data?.url,
              }));
            }}
            type="file"
            accept=".png, .jpg, .jpeg"
            className="fill-none my-3"
          />
        </div>
        <div className="flex flex-col w-full">
          <span>First name</span>
          <input
            onChange={(e) => {
              setInfomationUpdate((prev) => ({
                ...prev,
                firstName: e.target.value,
              }));
            }}
            value={infomationUpdate?.firstName}
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <div className="flex flex-col w-full">
          <span>Last name</span>
          <input
            onChange={(e) => {
              setInfomationUpdate((prev) => ({
                ...prev,
                lastName: e.target.value,
              }));
            }}
            value={infomationUpdate?.lastName}
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <button
          onClick={handleUpdateInfo}
          disabled={loadingChangeInfo}
          className="w-full flex mt-4 cursor-pointer hover:bg-opacity-85 justify-center items-center p-[6px] rounded-md bg-photo-time-pink-light"
        >
          {loadingChangeInfo ? (
            <Spin indicator={<LoadingOutlined spin />} />
          ) : (
            <span className="text-white">Change infomation</span>
          )}
        </button>
      </div>

      <div className="flex flex-col mt-1 2xl:w-[60%] xl:w-[70%] lg:w-[80%] w-[90%] bg-white 2xl:p-[18px] xl:p-[14px] lg:p-[12px] p-[10px] rounded-lg">
        <span className="font-semibold text-xl">Change password</span>
        <div className="flex flex-col w-full">
          <span>Password current</span>
          <input
            onChange={(e) => {
              setResetPassword((prev) => ({
                ...prev,
                oldPassword: e.target.value,
              }));
            }}
            type="password"
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <div className="flex flex-col w-full">
          <span>New password</span>
          <input
            onChange={(e) => {
              setResetPassword((prev) => ({
                ...prev,
                newPassword: e.target.value,
              }));
            }}
            type="password"
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <div className="flex flex-col w-full">
          <span>Confirm new password</span>
          <input
            onChange={(e) => {
              setResetPassword((prev) => ({
                ...prev,
                confirmPassword: e.target.value,
              }));
            }}
            type="password"
            className="w-full p-[6px] border-[1px] border-gray-400 rounded-md outline-none"
          ></input>
        </div>
        <button
          onClick={handleChangePassword}
          disabled={loadingChangePassword}
          className="w-full flex mt-4 cursor-pointer hover:bg-opacity-85 justify-center items-center p-[6px] rounded-md bg-photo-time-pink-light"
        >
          {loadingChangePassword ? (
            <Spin indicator={<LoadingOutlined spin />} />
          ) : (
            <span className="text-white">Change password</span>
          )}
        </button>
      </div>
    </div>
  );
};

export default AccountManage;
